export default {
  TNC_ERROR: "To log in, you must first accept the fielddrive's terms and conditions, and privacy policy.",
  WELCOME_BACK: "Welcome back! You've successfully logged in.",
  TNC_LABEL: 'By ticking this box you agree to the fielddrive leads',
  TNC: 'terms & conditions',
  TNC_LINK: 'https://www.fielddrive.com/terms-and-conditions',
  LOWER_AND: 'and',
  POLICY: 'privacy policy',
  POLICY_LINK: 'https://www.fielddrive.com/privacy-policy',
  POLICY_LABEL: 'You authorize fielddrive leads to process your personal data for the purposes therein specified.',
  LOGIN: 'Login'
}
